import { Box, styled } from '@mui/material';

export const StyledHolidayHoursBox = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(6)
}));
